<template>
  <modal transition="pop-out" name="update-payment-method-modal" :width="350" :height="250">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Pending">
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">Enable</label>
          <el-switch v-model="form.status"></el-switch>
        </div><br>
        <div class="flex justify-start">
          <el-button @click="update" type="primary" :updating="updating">Update</el-button>
          <el-button @click="closeDialog" type="text">Close</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'PaymentMethodUpdateForm',
  data() {
    return {
      error: false,
      updating: false,
    };
  },
  computed: {
    form() {
      return this.$store.state.SettingsModule.PaymentMethods.payment_method;
    },
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('update-payment-method-modal');
    },
    async update() {
      this.error = false;

      if (this.form.name !== '') {
        try {
          this.updating = true;
          await this.$store.dispatch('SettingsModule/PaymentMethods/updatePaymentMethod', {
            paymentMethodId: this.form.id, paymentMethod: this.form,
          });
          this.$modal.hide('update-payment-method-modal');
          this.$notify.success({
            title: 'Success',
            message: 'Payment method update was successful.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }

        this.updating = false;
      } else {
        this.error = true;
      }
    },
  },
};
</script>

<style scoped>

</style>
